import React from "react"
import { StyleSheet, View } from "react-native"
import { LinearGradient } from "expo-linear-gradient"
import { BFColors } from "@/constants/Colors"
import { useSafeAreaInsets } from "react-native-safe-area-context"

const FullScreenBackground = ({ preQual = false }: { preQual?: boolean }) => {
  const insets = useSafeAreaInsets()

  return (
    <View
      style={[
        styles.fullSize,
        {
          paddingTop: insets.top,
          paddingBottom: insets.bottom,
        },
      ]}
    >
      <LinearGradient
        style={StyleSheet.absoluteFill} // Ensures it covers the entire View
        colors={[BFColors.fsGradientStart, BFColors.fsGradientEnd]}
        start={{ x: 0, y: preQual ? 0.1 : 0 }}
        end={{ x: 0, y: 1 }}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  fullSize: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: BFColors.midnightBlue,
  },
})

export default FullScreenBackground
